import { Map as ImmMap } from 'immutable';
import { SHOW_PRODUCT_MODAL, HIDE_PRODUCT_MODAL } from './constants';

export const initialState = new ImmMap({
	productModalOpen: false,
	productId: 0,
	productSku: '',
});

const productModalReducer = (state = initialState, action) => {
	switch (action.type) {
		case SHOW_PRODUCT_MODAL: {
			const newstate = state.set('productModalOpen', true);
			const newerState = newstate.set('productSku', action.productSku);
			return newerState.set('productId', action.productId);
		}
		case HIDE_PRODUCT_MODAL: {
			return state.set('productModalOpen', false);
		}
		default:
			return state;
	}
};

export default productModalReducer;
